module.exports = __webpack_public_path__ + "static/vegan-cola_label_new-b9eec783e17d9af3bce2d6b5031069bc.jpg";